import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
